<template>
      <g-master name="forms2"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
      >
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <g-lookup :label="$t('Aprobador')"
                        :formItemConfig="fiOptions"
                        endpoint="personas"
                        :decorator="['approver_id', { rules: [{ required: false}] }]"
              >
              </g-lookup>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Aprobador principal')" v-bind="fiOptions">
                <a-select
                  v-decorator="[
                    'primary_approver',
                    { rules: [{ required: false}], initialValue: 'N' },
                  ]"
                >
                  <a-select-option value="Y">
                    SI
                  </a-select-option>
                  <a-select-option value="N">
                    NO
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown :label="$t('Tipo de proceso')"
                          :formItemConfig="fiOptions"
                          endpoint="wf_process_type"
                          :decorator="['process_type_id', { rules: [{ required: true, message:'Valor requerido'}] }]">
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <g-lookup :label="$t('Solicitante')"
                        :formItemConfig="fiOptions"
                        endpoint="personas"
                        :decorator="['person_id', { rules: [{ required: false}] }]"
              >
              </g-lookup>
            </a-col>
            <a-col v-show="false" v-bind="colOptions">
              <g-lookup :label="$t('Atributo 1')"
                        :formItemConfig="fiOptions"
                        endpoint="personas"
                        :decorator="['attribute1', { rules: [{ required: false}] }]"
              >
              </g-lookup>
            </a-col>
            <a-col v-bind="colOptions">
              <g-lookup :label="$t('Atributo 2')"
                        :formItemConfig="fiOptions"
                        endpoint="personas"
                        :decorator="['attribute2', { rules: [{ required: false}] }]"
              >
              </g-lookup>
            </a-col>
            <a-col v-bind="colOptions">
              <g-lookup :label="$t('Atributo 3')"
                        :formItemConfig="fiOptions"
                        endpoint="personas"
                        :decorator="['attribute3', { rules: [{ required: false}] }]"
              >
              </g-lookup>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="colOptions" :label="$t('Atributo 4')">
                <a-date-picker style="width: 100%"
                               v-decorator="['attribute4', { rules: [{ required: false }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item  :label="$t('Atributo 5', { rules: [{ required: false }] })" v-bind="fiOptions">
                <a-input
                  v-decorator="['attribute5', { rules: [{ required: false }] }]"/>
              </a-form-item>
            </a-col>
          </a-row>
        </template>
      </g-master>
</template>

<script>
  export default {
    data () {
      return {
        period_request: {h_lookup_type: 'PERIODOS_LIQUIDACION', use_code: true},
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'wf_approval_hierarchy',
          tableSetup: {
            tableConfig: {
              pagination: {
                pageSize: 10,
                showSizeChanger: true,
                pageSizeOptions: ['5', '10', '20', '30', '40'],
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
              },
              rowKey: 'approval_hierarchy_id'
            },
            columns: [
              {title: 'Solicitante', dataIndex: 'person_id_desc', sorter: true},
              {title: 'Aprobador', dataIndex: 'approver_id_desc', sorter: true},
              {title: 'Aprobador principal', dataIndex: 'primary_approver_desc'},
              {title: 'Tipo proceso', dataIndex: 'name_desc', sorter: true},
              {title: this.$t('Atributo 1'), dataIndex: 'attribute1_desc', sorter: true},
              {title: this.$t('Atributo 2'), dataIndex: 'attribute2_desc', sorter: true},
              {title: this.$t('Atributo 3'), dataIndex: 'attribute3_desc', sorter: true},
              {title: this.$t('Atributo 4'), dataIndex: 'attribute4_desc', sorter: true},
              {title: this.$t('Atributo 5'), dataIndex: 'attribute5', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'approver_id'},
            {name: 'person_id'},
            {name: 'process_type_id'},
            {name: 'attribute1'},
            {name: 'attribute2'},
            {name: 'attribute3'},
            {name: 'attribute4', type: 'date'},
            {name: 'attribute5'},
            {name: 'primary_approver'}
          ]
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/WfRequest/WfApprovalHierarchy.vue